import React from 'react';
import omit from 'lodash/omit';

export default function FieldStyle(props: any) {
  const { autoFocus, ...rest } = props;

  const InputRef = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    InputRef.current?.focus();
  }, []);

  return (
    <input
      className="shadow-sm focus:ring-primary-500 focus:border-primary-500 block w-full sm:text-sm border-gray-300 rounded-md"
      ref={InputRef}
      type="text"
      {...omit(rest, ['onSave'])}
    />
  );
}
